import React from 'react';
import { withRouter } from 'react-router-dom';
import shortid from 'shortid';

const BrowseByList = (props) => {
  return (
    <React.Fragment>
      <h2>{props.heading}</h2>
      {!!props.list && props.list.length > 0 ? (
        <ul>
          {props.list.map((item) => (
            <li
              onClick={(e) => {
                e.preventDefault();
                props.history.push(item.url.replace('/api/v1', ''));
              }}
              key={shortid.generate()}
            >
              {item.name}
            </li>
          ))}
        </ul>
      ) : (
        <p>
          <strong>No item found</strong>
        </p>
      )}
    </React.Fragment>
  );
};

export default withRouter(BrowseByList);
